export const storePath = vendor => vendor?.storePath || (vendor?.branch?.slug ? `/${vendor.branch.slug}/${vendor.slug || vendor._id}/` : `/vendor/${vendor?.slug || vendor?._id}`);
export const storeProductPath = (vendor, slug) => `${storePath(vendor).replace(/\/$/, '')}/product/${slug}`;
